import { useSelector } from 'react-redux';

const useIsBuyer = () => {
  const primaryInterest = useSelector(state => state.auth.currentUser.primary_interest);
  return primaryInterest === 'buy';
};

export default useIsBuyer;
